export default __webpack_public_path__ + "static/media/johnny-depp-js.4af79a7b.jpeg";